import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { parse, format, AsYouType } from 'libphonenumber-js';
import {EventsService} from 'angular4-events';
import { ImageCroppedEvent } from 'ngx-image-cropper';

declare var Nanobar: any;

declare var $: any;
declare var google: any;
declare var toastr: any;
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
 nao = new Nanobar();
  categoryData: any;
  categoryData1: any;
  paginatedData: any;
  rejectId: any;
  page = 0;
  last_page: any;
  once = false;
  paging_once = false;
  paging = false;
  pushReceive: any;
  limit: any;
  catAddError: any;
  description = '';
  acceptId: any;
  btnShowAfterLoad = false;
  searchCategory = '';
  clearTimeout: any;
  filterValue = 'All';
  filterValCount = 0;
  noDataFoundSearch = false;
  type = 'data';
  defaultViewToShow = false;
  productName: any;
  typeData: any;
  removeSuccess: any;
  removeMsg: any;
  productTypeId: any;
  disableClick: any;
  removeProductTypeNameConfirm: any;
  editProductName = '';
  editDescription = '';
  editid: any;
  editSuccess: any;
  categoryImage = '';
  categoryImageEdit = '';
  imageChangedEvent: any;
  ImageCroppedEvent: any;
  imageChangedEventEdit: any;
  ImageCroppedEventEdit: any;
  editimage = '';
  is_category: any;
  catIdAll = -1;
  servicesDatas: any;
  serviceName = 'Services - All';
  city: any;
  servicedetail: any;
  dataOrdersListing: any;
  city_id: any;
  dispensaryDetails: any;
  businessName = 'Business - All';
  dispensaryId: any;
  outletDatas: any;
  dispensary_id: any;
  completeOutletData: any;
  outletId = -1;
  outletName = 'Outlet - All';
  businessDetailforOrder: any;
  businessForOrders = 'Business';
  businessIdForOrders =  '-1';
  serviceCityIdForOrders: any;
  serviceCityForOrders: any = 'Services - All';
  serviceCity: string;
  searchBusinessDetailforOrder: any;
  searchBusiness: any;
  searchTimeOut: any;

  constructor(private dataService: DataService,  private pubsub: EventsService) {
    this.dataService.pageName = 'Category listing';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  clearSearch() {
    this.searchCategory = '';
    this.filterSearch();
  }

  categorylist() {
    this.nao.go(30);
    this.noDataFoundSearch = false;
    this.type = 'data';
    this.categoryData = [];
    this.btnShowAfterLoad = false;
    console.log('login data');
    this.dataService.getCateogryList(window.localStorage.getItem('token'), this.businessIdForOrders).subscribe(
      (data) => {
        this.nao.go(100);
        console.log('customer data', data);
        this.categoryData = [];
        this.categoryData = data;
        if (this.categoryData.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.categoryData.rest_error_code === 2) toastr.error('Please login again');
        if (this.categoryData.rest_error_code === 4) toastr.error('Doest not exist');
        this.limit = 2;
        this.last_page = this.categoryData.last_page;
        this.page++;
        this.categoryData = this.categoryData.items;
        if (this.categoryData.length === 0) {
            this.defaultViewToShow = true;
        }
        this.btnShowAfterLoad = true;
         for (var i = 0; i < this.categoryData.length; i++) {
           if (this.categoryData[i].is_featured === false) {
            $( '#chkedMain' ).on( 'load', function() {
              $('#feature' + i).prop('checked', true);
            });
          }
          if (this.categoryData[i].country_code === '+1') {
          this.categoryData[i].phone_number = format(this.categoryData[i].phone_number, 'US', 'NATIONAL');
          console.log('this.categoryData[i].number', this.categoryData[i].phone_number);
          }
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  acceptCategoryFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    console.log('login data');
    this.dataService.acceptCategory(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.categorylist();
        $('#acceptCategoryPop').modal('hide');
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  acceptCategoryPopOpen(id) {
    this.acceptId = id;
    $('#acceptCategoryPop').modal('show');
  }
  rejectCategoryPopOpen(id) {
    this.rejectId = id;
    $('#rejectCategoryPop').modal('show');
  }
  rejectCategoryFunction (id) {
    this.disableClick = true;
    this.nao.go(30);
    console.log('login data');
    this.dataService.rejectCategory(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.categorylist();
        $('#rejectCategoryPop').modal('hide');
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  getCategoryListByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getCateogryListPage(window.localStorage.getItem('token'), this.page).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedData = data;
        // this.limit = this.paginatedData.limit;
        this.last_page = this.paginatedData.last_page;
        this.paginatedData = this.paginatedData.items;
        for (var i = 0; i < this.paginatedData.length; i++) {
          if (this.paginatedData[i].country_code === '+1') {
          this.paginatedData[i].phone_number = format(this.paginatedData[i].phone_number, 'US', 'NATIONAL');
          console.log('this.categoryData[i].number', this.paginatedData[i].phone_number);
          }
        }
        console.log('paginated before concat data', this.paginatedData);
        this.page++;
        // this.paging = false;
        // this.once = false;
        // this.paging_once = false;
        for (var i = 0; i < this.paginatedData.length; i++) {
          this.categoryData.push(this.paginatedData[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  //  filterValUpdate(val) {
  //   this.filterValue = val;
  //   if (val === 'All') {
  //     this.filterValCount = 0;
  //     this.filterSearch();
  //   }
  //   if (val === 'Online') {
  //     this.filterValCount = 1;
  //     this.filterSearch();
  //   }
  //   if (val === 'Offline') {
  //     this.filterValCount = 2;
  //     this.filterSearch();
  //   }
  //   if (val === 'Pending') {
  //     this.filterValCount = 3;
  //     this.filterSearch();
  //   }
  //   if (val === 'Approved') {
  //     this.filterValCount = 4;
  //     this.filterSearch();
  //   }
  // }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    this.type = 'search';
    this.categoryData = [];
    this.btnShowAfterLoad = false;
    this.page = 0;
    // if (this.searchCategory === '') {
    //   return;
    // }
    this.nao.go(30);
    console.log('login data');
    this.dataService.searchCategory(window.localStorage.getItem('token'), this.searchCategory, this.businessIdForOrders).subscribe(
      (data) => {
        this.nao.go(100);
        this.categoryData = data;
        this.last_page = this.categoryData.last_page;
        this.page++;
        this.categoryData = this.categoryData.items;
        if (this.categoryData.length === 0) {
          this.noDataFoundSearch = true;
        }
        this.btnShowAfterLoad = true;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
  openpAddTypePop() {
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    $('#catImageEmpty').css('border', '0px');
    this.productName = '';
    this.description = '';
      $('#addProductTypePop').modal('show');
    }
  addProductTypeFunction() {
    this.disableClick = true;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    $('#catImageEmpty').css('border', '0px');
    var count = 0;
    if (this.productName === '' || this.productName === undefined) {
      $('#productTypeName label').css('color', '#a10a0d');
      $('#productTypeName input').css('border-color', '#a10a0d');
      count++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description textarea').css('border-color', '#a10a0d');
      count++;
    }
    if (this.categoryImage === '') {
      $('#catImageEmpty').css('border', '1px solid #a10a0d');
      count++;
    }
    if (count > 0) {
      this.disableClick = false;
      return;
    }
    var catImage = this.categoryImage.split(',')[1];
    this.dataService.addProductType(window.localStorage.getItem('token'), this.productName, this.description, catImage).subscribe(
      (data) => {
        this.typeData = data;
        this.catAddError = data;
        this.catAddError = this.catAddError.message;
        this.typeData = this.typeData.success;
        if (this.typeData === true) {
          $('#addProductTypePop').modal('hide');
          toastr.success('Category ' + this.productName + ' added successfully');
          this.categorylist();
        }
        if (this.typeData === false) {
          toastr.error(this.catAddError);
        }
        this.disableClick = false;
      },
      (error) => {
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }
  featuredCategoryFuntion (id) {
    this.nao.go(30);
    console.log('login data');
    this.dataService.featuredCategory(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
   chkFeatured(id, index) {
    // if ($('#feature' + index).prop('checked') === true) {
    //   console.log('in chk');
      this.featuredCategoryFuntion(id);
    // }
  }
   openPop(id, name) {
    this.productTypeId = id;
    this.removeProductTypeNameConfirm = name;
    $('#productTypeRemovePop').modal('show');
  }
   removeProductTypeFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    this.dataService.removeProductType(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.removeSuccess = data;
        this.removeMsg = this.removeSuccess.message;
        this.removeSuccess = this.removeSuccess.success;
        if (this.removeSuccess === true) {
          // this.filterSearch();
          for(var i = 0; i < this.categoryData.length; i++) {
            if(id === this.categoryData[i].id){
              console.log(id, this.categoryData[i].id);
              this.categoryData.splice(i , 1);
              console.log('this.driverData', this.categoryData);
            }
          }
          $('#productTypeRemovePop').modal('hide');
          toastr.success(this.removeMsg);
        }
        if (this.removeSuccess === false) {
          toastr.error(this.removeMsg);
        }
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        this.disableClick = false;
      }
    );
  }
    openPopSubCategory(id, name) {
    this.productTypeId = id;
    this.removeProductTypeNameConfirm = name;
    $('#subCategoryTypeRemovePop').modal('show');
  }
   removeSubCategoryTypeFunction(id) {
    this.disableClick = true;
    this.nao.go(30);
    this.dataService.removeSubCategory(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.removeSuccess = data;
        this.removeMsg = this.removeSuccess.message;
        this.removeSuccess = this.removeSuccess.success;
        if (this.removeSuccess === true) {
          // this.productslist();
          // this.filterSearch();
          for(var i = 0; i < this.categoryData.length; i++) {
            for(var j = 0; j < this.categoryData[i].sub_categories.length; j++){
              if(id === this.categoryData[i].sub_categories[j].id){
                console.log(id, this.categoryData[i].sub_categories[j].id);
                this.categoryData[i].sub_categories.splice(j , 1);
                console.log('this.driverData', this.categoryData);
              }
            }
          }
          $('#subCategoryTypeRemovePop').modal('hide');
          // toastr.success(this.removeMsg);
        }
        if (this.removeSuccess === false) {
          toastr.error(this.removeMsg);
        }
        this.disableClick = false;
      },
      (error) => {
        this.nao.go(100);
        this.disableClick = false;
      }
    );
  }

  editpopOpen(obj, value) {
    this.is_category = value;
    this.editimage = '';
    this.categoryImageEdit = '';
    console.log('obj', obj);
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    $('#catImageEmptyEdit').css('border', '0px');
    this.editProductName = obj.name;
    this.editDescription = obj.description;
    this.editid = obj.id;
    this.editimage = obj.category_image;
    // this.categoryImageEdit = obj.category_image;
    console.log('this.editimage', this.editimage);
    $('#editproductPop').modal('show');
  }

  editProductTypeFunction() {
    this.disableClick = true;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    $('#catImageEmptyEdit').css('border', '0px');
    var count = 0;
    console.log('editProductName', this.editProductName);
    if (this.editProductName === '' || this.editProductName === undefined) {
      $('#editProductTypeName label').css('color', '#a10a0d');
      $('#editProductTypeName input').css('border-color', '#a10a0d');
      count++;
    }
    if (this.editDescription === '' || this.editDescription === undefined) {
      $('#editDescription label').css('color', '#a10a0d');
      $('#editDescription textarea').css('border-color', '#a10a0d');
      count++;
    }
    if (this.categoryImageEdit === '' && this.editimage === '') {
      $('#catImageEmptyEdit').css('border', '1px solid #a10a0d');
      count++;
      console.log('categoryImageEdit', this.categoryImageEdit);
    } else {
      var catImage = this.categoryImageEdit.split(',')[1];
    }
    if (count > 0) {
      this.disableClick = false;
      return;
    }
    this.dataService.editProductType(window.localStorage.getItem('token'), this.editProductName, this.editDescription, this.editid, this.is_category, catImage).subscribe(
      (data) => {
        this.editSuccess = data;
        this.editSuccess = this.editSuccess.success;
        if (this.editSuccess === true) {
          this.disableClick = false;
          // this.categorylist();
          this.categorylistofSpecificCatorSubCat();
          $('#editproductPop').modal('hide');
          toastr.success('Category edited successfully');
        } else {
          this.disableClick = false;
        }
      },
      (error) => {
        console.log('error', error);
        this.disableClick = false;
      }
    );
  }

  categorylistofSpecificCatorSubCat() {
    this.dataService.getCateogryList1(window.localStorage.getItem('token'), this.editid, this.is_category).subscribe(
      (data) => {
        this.categoryData1 = data;
        this.categoryData1 = this.categoryData1.items[0];
        console.log(this.categoryData1);
        if(this.is_category === '0'){
          for(var i = 0; i < this.categoryData.length; i++){
            if( this.categoryData[i].id === this.editid){
              this.categoryData[i].name = this.categoryData1.name;
              this.categoryData[i].description = this.categoryData1.description;
              this.categoryData[i].category_image = this.categoryData1.category_image;
            }
          }
        }

        if(this.is_category === '1'){
          for(var i = 0; i < this.categoryData.length; i++){
            for(var j = 0; j < this.categoryData[i].sub_categories.length; j++){
              if( this.categoryData[i].sub_categories[j].id === this.editid){
                for(var k =0; k < this.categoryData1.sub_categories.length; k++){
                  if(this.categoryData1.sub_categories[k].id === this.editid){
                    this.categoryData[i].sub_categories[j].name = this.categoryData1.sub_categories[k].name;
                    this.categoryData[i].sub_categories[j].description = this.categoryData1.sub_categories[k].description;
                    this.categoryData[i].sub_categories[j].category_image = this.categoryData1.sub_categories[k].category_image;
                    this.categoryData[i].sub_categories[j].status = this.categoryData1.sub_categories[k].status;
                  }
                }
              }
            }
          }
        }

        if(this.is_category === '2'){
          for(var i = 0; i < this.categoryData.length; i++){
            for(var j = 0; j < this.categoryData[i].sub_categories.length; j++){
              for(var k = 0; k < this.categoryData[i].sub_categories[j].child_categories.length; k++) {
                if( this.categoryData[i].sub_categories[j].child_categories[k].id === this.editid){
                  for(var l = 0; l < this.categoryData1.sub_categories.length; l++) {
                    for(var m = 0; m < this.categoryData1.sub_categories[l].child_categories.length; m++) {
                      if(this.categoryData1.sub_categories[l].child_categories[m].id === this.editid) {
                        this.categoryData[i].sub_categories[j].child_categories[k].name = this.categoryData1.sub_categories[l].child_categories[m].name;
                        this.categoryData[i].sub_categories[j].child_categories[k].description = this.categoryData1.sub_categories[l].child_categories[m].description;
                        this.categoryData[i].sub_categories[j].child_categories[k].category_image = this.categoryData1.sub_categories[l].child_categories[m].category_image;
                        this.categoryData[i].sub_categories[j].child_categories[k].status = this.categoryData1.sub_categories[l].child_categories[m].status;
                      }
                    }
                  }
                }
              }
            }
          }
        }


      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  selectImage() {
    $('#categoryImageInput').click();
  }
  fileChangeEvent(event: any): void {
    if ($('#categoryImageInput').val() !== '') {
      $('#cropperImgPop').modal('show');
      setTimeout(() => {
        this.imageChangedEvent = event;
      }, 500);
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.categoryImage = event.base64;
    console.log('profileImgFinal', this.categoryImage);
  }
  clearCategoryImage(){
    $('#cropperImgPop').modal('hide');
  }
  doneCategoryImage(){
    $('#cropperImgPop').modal('hide');
    $('#catImage').attr('src', this.categoryImage);
  }


  selectImageEdit() {
    $('#categoryImageInputEdit').click();
  }
  fileChangeEventEdit(event: any): void {
    if ($('#categoryImageInputEdit').val() !== '') {
      $('#editCategorycropper').modal('show');
      setTimeout(() => {
        this.imageChangedEvent = event;
      }, 500);
    }
  }
  imageCroppedEdit(event: ImageCroppedEvent) {
    this.categoryImageEdit = event.base64;
    console.log('profileImgFinal', this.categoryImageEdit);
  }
  clearCategoryImageEdit(){
    $('#editCategorycropper').modal('hide');
  }
  doneCategoryImageEdit(){
    $('#editCategorycropper').modal('hide');
    $('#catImageEdit').attr('src', this.categoryImageEdit);
  }

  ngOnInit() {
    var context = this;
    this.categorylist();
    this.getServices();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#categories').css('color', '#d77229');
  }



  createOrder(id, name){
    
    this.businessIdForOrders = id;
    console.log(this.businessIdForOrders);
    this.businessForOrders = name;
    this.categorylist();
  }

  createOrderService(id, cityName, random = '') {
    this.serviceCityIdForOrders = id;
    if (cityName == 'Services - All') {
      this.serviceCityForOrders = 'Services - All';
      this.serviceCity = '';
    } else {
      this.serviceCityForOrders = cityName;
      this.serviceCity = cityName;
    }
    this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.serviceCity, '').subscribe(
      (data) => {
        this.businessDetailforOrder = data;
        this.searchBusinessDetailforOrder = data;
        this.businessForOrders= 'Business';
      },
      (error) => {
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }

  getServices(){

    this.dataService.getservices(localStorage.getItem('token')).subscribe(
      (data) => {
        this.servicesDatas = data;
        console.log('this.servicesDatas', this.servicesDatas);
        this.servicesDatas = this.servicesDatas.city_list;
        this.categorylist();

      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }

  filterServiceId(city){
    // this.pageLoad = 0;
    console.log('cityfilter', city);

    this.serviceName = city;
    this.city_id =city;

    if (this.serviceName == 'All'){

      this.serviceName = 'Services - All';
    }
    if (this.serviceName != 'Services - All')

    {
      this.city_id = city;
    }
    else if (this.serviceName == 'Services - All')
   {
    this.city_id = '-1';
   }
   
    this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.city_id, '').subscribe(
      (data) => {
        this.nao.go(100);
        this.servicedetail = data;
        console.log('Cities', this.servicedetail);
          this.dispensaryDetails = data;
          this.filterBusinessId(-1, name, '');
          this.categorylist();
  
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }

  filterBusinessId(id, name, detail){
    this.dispensary_id = id;
  
    if (this.dispensary_id == -1){
      this.businessName = 'All Businesses';  
    }
    
    if (this.dispensary_id != -1) {
      this.businessName = name; 
      
    }
    
    console.log('dispansaryid', id);
    this.outlets();
    this.outletId = -1;
    
    this.categorylist();

  }

  outlets(){
    this.dataService.getoutlets(localStorage.getItem('token'), this.dispensary_id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.completeOutletData = data;
        this.outletDatas = data;
        this.outletDatas = this.outletDatas.items;
        this.outletName = 'Outlet - All';

        console.log('call in first function', this.outletDatas);

      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
        toastr.error('Some thing went wrong');
      }
    );
  }
  showSearchResults: boolean = false;

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.serviceCity, this.searchBusiness).subscribe(
      (data) => {
        this.showSearchResults = true;
        this.searchBusinessDetailforOrder = data;
      },
      (error) => {
          console.log('error', error);
          toastr.error('Some thing went wrong');
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/categories/categories.component.ts